import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GroupRenewDropoutComponent } from './component/group-renew-dropout/group-renew-dropout.component';
import { GroupRenewalLandingComponent } from './component/group-renewal-landing/group-renewal-landing.component';
import { GroupRenewalLoginComponent } from './component/group-renewal-login/group-renewal-login.component';
import { GroupRenewalPaymentProcessingComponent } from './component/group-renewal-payment-processing/group-renewal-payment-processing.component';
import { GroupRenewalThankYouComponent } from './component/group-renewal-thank-you/group-renewal-thank-you.component';
import { GroupRenewalDownloadApiComponent } from './component/group-renewal-download-api/group-renewal-download-api.component'
import { PaymentGatewayComponent } from './common-shared-modules/payment-gateway/payment-gateway.component';



const routes: Routes = [
  { path: '', redirectTo: 'renewal-group', pathMatch: 'full' },
  {
    path: 'renewal-group', component: GroupRenewalLoginComponent, pathMatch: 'full',
    data: { title: 'Group Renew Policy - Aditya Birla Health Insurance', }
  },

  {
    path: 'group-renew-dropout', component: GroupRenewDropoutComponent, pathMatch: 'full',
    data: { title: 'Group Renewal Renew Dropout - Aditya Birla Health Insurance', }
  },

  {
    path: 'group-renew-landing', component: GroupRenewalLandingComponent, pathMatch: 'full',
    data: { title: 'Group Health Insurance - Aditya Birla Health Insurance', }
  },

  {
    path: 'group-renewal-payment-processing', component: GroupRenewalPaymentProcessingComponent, pathMatch: 'full',
    data: { title: 'Payment Processing  - Aditya Birla Health Insurance', }
  },

  {
    path: 'group-renewal-thank-you', component: GroupRenewalThankYouComponent, pathMatch: 'full',
    data: { title: 'Group Renewal thank You - Aditya Birla Health Insurance', }
  },

  {
    path: 'group-renewal-download-coi', component: GroupRenewalDownloadApiComponent, pathMatch: 'full',
    data: { title: 'Group Renew Download COI - Aditya Birla Health Insurance', }
  },
  {
    path: 'payment-gateway', component: PaymentGatewayComponent, pathMatch: 'full',
    data: { title: 'Payment Gateway  - Aditya Birla Health Insurance', }
  },
  { path: '**', component: GroupRenewalLoginComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
